var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import SimplePanel from '@/shared/components/SimplePanel';
import messages from '@/modules/tasks/weekplanner/weekPlannerMessages';
import { useIntl } from 'react-intl';
import { FilterUserSearch } from '@/shared/components/input/filterInputs/FilterUserSearch';
import { FilterStatusSelect } from '@/shared/components/input/filterInputs/FilterStatusSelect';
import { FilterTaskTemplateMultiSelect } from '@/shared/components/input/filterInputs/FilterTaskTemplateMultiSelect';
import { FilterDelayedWeekPicker } from '@/shared/components/input/filterInputs/FilterDelayedDateRangePicker';
import { FilterWrapper } from '@/shared/components/FilterWrapper';
import Button from '@/shared/components/Button';
import { AddIcon } from '@/shared/components/Icons';
import { CanCreate } from '@/shared/components/security';
import Toggle from 'react-toggle';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import AuthService from '@/shared/services/AuthService';
import WeekPlannerPeriods from './WeekPlannerPeriods';
import { WeekPlannerFilterType } from '../constants';
export var WeekPlannerHeader = function (_a) {
    var activeFilters = _a.activeFilters, defaultFilters = _a.defaultFilters, setFilter = _a.setFilter, onCreateToDo = _a.onCreateToDo, onTogglePlanTasks = _a.onTogglePlanTasks, isPlanTasksOpen = _a.isPlanTasksOpen, _b = _a.showWeekend, showWeekend = _b === void 0 ? false : _b, onToggleWeekend = _a.onToggleWeekend, _c = _a.weekendTaskCount, weekendTaskCount = _c === void 0 ? 0 : _c;
    var formatMessage = useIntl().formatMessage;
    var weekendToggle = (_jsxs("div", __assign({ className: "week-planner-weekend-toggle" }, { children: [_jsxs("label", __assign({ className: "react-toggle-wrapper" }, { children: [_jsx(Toggle, { checked: showWeekend, onChange: function (e) { return onToggleWeekend === null || onToggleWeekend === void 0 ? void 0 : onToggleWeekend(e.target.checked); } }), _jsx("span", __assign({ className: "label-text" }, { children: formatMessage(messages.ShowWeekend) }))] })), weekendTaskCount > 0 && (_jsx(OverlayTrigger, __assign({ trigger: ['hover', 'focus'], placement: "bottom", overlay: _jsx(Tooltip, __assign({ id: "week-planner-weekend-tooltip", className: "week-planner-weekend-tooltip" }, { children: formatMessage(messages.WeekendTasksTooltip, { count: weekendTaskCount }) })) }, { children: _jsx("i", { className: "fa fa-fw fa-exclamation-triangle text-warning margin5L" }) })))] })));
    var dateChanged = function (startDate, endDate) {
        setFilter({
            executionDateFrom: startDate.format('YYYY-MM-DD'),
            executionDateUntil: (endDate !== null && endDate !== void 0 ? endDate : startDate.clone().add(6, 'days')).format('YYYY-MM-DD'),
        });
    };
    var resetFilters = function () { return setFilter(defaultFilters); };
    var hasActiveFilters = function () {
        var _a;
        return !!activeFilters.status ||
            ((_a = activeFilters.taskTemplates) === null || _a === void 0 ? void 0 : _a.length) > 0 ||
            activeFilters.userId !== AuthService.getUserId() ||
            activeFilters.executionDateFrom !== defaultFilters.executionDateFrom ||
            activeFilters.executionDateUntil !== defaultFilters.executionDateUntil ||
            !!activeFilters.showWeekend;
    };
    return (_jsx(SimplePanel, __assign({ article: "22681112356124", title: formatMessage(messages.WeekPlanner), buttons: _jsxs(_Fragment, { children: [_jsxs(Button, __assign({ btnClassName: "btn btn-xs btn-inverse margin10R", onClick: onTogglePlanTasks }, { children: [_jsx("span", __assign({ className: "margin5R" }, { children: _jsx("i", { className: "fa ".concat(isPlanTasksOpen ? 'fa-chevron-right' : 'fa-chevron-left'), "aria-hidden": "true" }) })), formatMessage(messages.PlanTasks)] })), _jsx(CanCreate, __assign({ on: "Todo" }, { children: _jsxs(Button, __assign({ btnClassName: "btn btn-xs btn-inverse margin10R", onClick: onCreateToDo }, { children: [_jsx("span", __assign({ className: "margin5R" }, { children: _jsx(AddIcon, {}) })), formatMessage(messages.CreateNewToDo)] })) }))] }) }, { children: _jsx("div", __assign({ className: "info-block container-fluid" }, { children: _jsx(FilterWrapper, __assign({ filterObject: activeFilters, setFilter: setFilter, hasActiveFilters: hasActiveFilters, resetFilters: resetFilters, screen: "WeekPlanner", invisibleFilters: [WeekPlannerFilterType.showWeekend], bottomElement: weekendToggle }, { children: [
                    FilterDelayedWeekPicker({
                        startDateItem: WeekPlannerFilterType.executionDateFrom,
                        endDateItem: WeekPlannerFilterType.executionDateUntil,
                        startDateId: 'ExecutionDateStartFilter',
                        endDateId: 'ExecutionDateEndFilter',
                        startDatePlaceholder: formatMessage(messages.ExecutionDateFrom),
                        endDatePlaceholder: formatMessage(messages.ExecutionDateUntil),
                        setFilter: setFilter,
                        activeFilters: activeFilters,
                        enabled: true,
                        isWeekPicker: true,
                        required: true,
                    }),
                    FilterUserSearch({
                        item: WeekPlannerFilterType.userId,
                        label: formatMessage(messages.ForEmployee),
                        isAlwaysVisible: true,
                        withUnassigned: false,
                        withNotAssignedToMe: false,
                        setFilter: setFilter,
                        activeFilters: activeFilters,
                        enabled: true,
                    }),
                    FilterTaskTemplateMultiSelect({
                        item: WeekPlannerFilterType.taskTemplates,
                        label: formatMessage(messages.SelectTask),
                        isAlwaysVisible: true,
                        setFilter: setFilter,
                        activeFilters: activeFilters,
                        enabled: true,
                    }),
                    FilterStatusSelect({
                        item: WeekPlannerFilterType.status,
                        label: formatMessage(messages.Status),
                        isAlwaysVisible: true,
                        setFilter: setFilter,
                        activeFilters: activeFilters,
                        enabled: true,
                    }),
                    {
                        filterItem: 'weekNavigationButtons',
                        enabled: true,
                        element: _jsx(WeekPlannerPeriods, { filters: activeFilters, onChangeDate: dateChanged }),
                    },
                ] })) })) })));
};
